<template>
  <div>
    <template v-for="(betsGroup, je) in betDataMatched">
      <div
        :key="'bets' + je"
        class="caption px-2 pl-3 text-white font-weight-bold pt-2 pb-1"
      >
        {{ betsGroup.matchName }}
      </div>
      <div v-for="(betData, y) in betsGroup.markets" :key="'markets' + y + je">
        <div class="caption text-white px-4 pl-3">
          {{ betData.name }}
        </div>
        <div v-for="(runner, u) in betData.runners" :key="'runners' + u + je">
          <v-card
            v-for="(bet, j) in runner.bets"
            :key="'runner' + j"
            light
            :class="{
              secondary: bet.type == 'BACK',
              accent: bet.type == 'LAY',
              opacityLess: bet.status == 'VOID_VAR'
            }"
            class="pa-2 mybet-card caption"
            :to="
              bet.parentCategory
                ? `/sportsbook/${bet.eventType}/${bet.parentCategory.parentCategory}/${bet.parentCategory._id}`
                : ''
            "
          >
            <div class="font-weight-bold">
              <span v-if="bet.betType === 'fancy'">{{
                bet.type == 'BACK' ? 'YES' : 'NO'
              }}</span>
              <span v-if="bet.betType !== 'fancy'"> {{ bet.type }}</span>
              {{ bet.horse }} for {{ bet.stake | currencyFormat }} @
              <span
                v-if="bet.betType !== 'fancy' && bet.betType !== 'lineLadder'"
              >
                {{
                  (bet.betType !== 'matchOdds' && bet.placeBetCalcType === 1
                    ? (bet.averagePriceMatched - 1) * 100
                    : bet.betType !== 'matchOdds' && bet.placeBetCalcType === 2
                    ? bet.averagePriceMatched - 1
                    : bet.averagePriceMatched) | currencyFormat(3)
                }}
              </span>
              <span v-if="bet.betType === 'lineLadder'">
                {{
                  (bet.betType !== 'matchOdds' && bet.placeBetCalcType === 1
                    ? (bet.averagePriceMatched - 1) * 100
                    : bet.betType !== 'matchOdds' && bet.placeBetCalcType === 2
                    ? bet.averagePriceMatched - 1
                    : bet.averagePriceMatched) | ceil
                }}
              </span>
              
              <span
                v-if="
                  bet.eventType &&
                  (bet.eventType === 'Horse Racing' ||
                    bet.eventType === 'Greyhound Racing') &&
                  bet.betType === 'fancy'
                "
              >
                {{
                  (bet.betType !== 'matchOdds' && bet.placeBetCalcType === 1
                    ? (bet.averagePriceMatched - 1) * 100
                    : bet.betType !== 'matchOdds' && bet.placeBetCalcType === 2
                    ? bet.averagePriceMatched - 1
                    : bet.averagePriceMatched) | currencyFormat(3)
                }}
              </span>
              <span v-if="bet.betType === 'fancy'">
                {{ ((bet.averagePriceMatched - 1) * 100) | currencyFormat }}
              </span>
              {{ bet.type == 'BACK' ? 'to win' : 'liability' }}
              <span
                v-if="
                  bet.betType !== 'bookMaker' && bet.betType !== 'lineLadder'
                "
              >
                {{
                  ((bet.averagePriceMatched - 1) * bet.stake) | currencyFormat
                }}
              </span>
              <span v-if="bet.betType === 'bookMaker'">
                {{
                  ((bet.averagePriceMatched - 1) * bet.stake)
                    | currencyFormat(2)
                }}
              </span>
              <span v-if="bet.betType === 'lineLadder'">
                {{ ((bet.betRate - 1) * bet.stake) | currencyFormat(2) }} </span
              >.
            </div>
            <div v-if="bet.status === 'VOID_VAR'" class="red--text title">
              Void by VAR
            </div>
            <div v-if="bet.status === 'RT_INVALID_BET'" class="red--text title">
              INVALID BET
            </div>
            <div
              v-if="bet.status === 'RT_INVALID_BET' && bet.reason"
              class="red--text small"
            >
              Reason:{{ bet.reason }}
            </div>
            <div>
              <span>{{ betData.name }}</span>
            </div>

            <div>
              <span>Placed: </span>
              {{ $moment(bet.placedDate).format('DD/MM/YYYY, h:mm:ss a') }}
            </div>
          </v-card>
        </div>

        <!-- <v-divider :key="'1' + je"></v-divider> -->
      </div>
    </template>
    <!-- <div v-if="!betDataMatched.length">
      <no-result text="No matched bets."></no-result>
    </div> -->
  </div>
</template>

<script>
// import NoResult from '@/components/NoResult'
export default {
  // components: { NoResult },
  props: {
    betDataMatched: { type: Array, default: () => [], required: true }
  }
}
</script>
